import React, { lazy } from 'react';
const images = ['https://cdn.magicpatterns.com/uploads/gefqiS4WRLhHw7jN9xb8XS/2_7ec09eea-8db7-401c-b3cf-4c38a57d2468.webp', 'https://cdn.magicpatterns.com/uploads/5fJb4FEA16hLmNnGQt7H69/4_80e8705e-bbe6-4e8b-b55a-b71c581742c4.webp', 'https://cdn.magicpatterns.com/uploads/fFH7d8qCYNub5DL5LeMooD/3_d9ef347f-2bd3-48a1-83c9-721a8c44aef0.webp', 'https://cdn.magicpatterns.com/uploads/w4uZH1GAVkqVKURaLmqgCr/5_6c5a0c76-f3fc-42a4-a1c7-9b976ac0c7ce.webp'];
export function ImageCarousel() {
  return <section className="py-8 md:py-12 bg-white overflow-hidden pt-[0px] pb-[0px]" data-id="element-167">
      <div className="flex w-max group" style={{
      animation: 'carousel-scroll 35s linear infinite'
    }} onMouseEnter={e => {
      ;
      (e.currentTarget as HTMLDivElement).style.animationPlayState = 'paused';
    }} onMouseLeave={e => {
      ;
      (e.currentTarget as HTMLDivElement).style.animationPlayState = 'running';
    }} data-id="element-168">
        {/* Duplicate images 3x for seamless infinite loop */}
        {[...images, ...images, ...images].map((src, index) => <div key={index} className="flex-shrink-0 px-2 md:px-3" data-id="element-169">
            <img src={src} alt="" className="w-64 h-64 md:w-72 md:h-72 object-cover rounded-xl shadow-[0_4px_20px_rgba(0,0,0,0.08)]" loading="lazy" data-id="element-170" />
          </div>)}
      </div>
    </section>;
}